var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-modal", {
    attrs: {
      "modal-title": _vm.$t("pages.permission.confirm_waiting"),
      "show-spinner": _vm.isLoading,
      "show-modal": _vm.showModal,
      "loading-primary-footer-button": _vm.isLoading,
      showPrimaryFooterButton: _vm.confirmWaiting,
    },
    on: _vm._d({}, [
      _vm.primaryEvent,
      _vm.onPrimaryButtonClicked,
      _vm.secondaryEvent,
      _vm.onCloseButtonClicked,
      _vm.closeEvent,
      _vm.onCloseButtonClicked,
    ]),
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("suc-form-has-error", { attrs: { form: _vm.form } }),
            _vm.confirmWaiting
              ? [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("appointment-status-field", {
                          attrs: {
                            id: "status",
                            name: "status",
                            form: _vm.form,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("absence-comment-field", {
                          attrs: {
                            id: "absence-comment",
                            name: "comments",
                            form: _vm.form,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              : [
                  _vm.isInitialized && _vm.detail.id
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("suc-text-form-show-field", {
                              attrs: {
                                title: _vm.$t("pages.permission.absences.id"),
                                value: _vm.detail.id,
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm.isInitialized && _vm.detail.isPermission()
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("suc-text-form-show-field", {
                              attrs: {
                                title: _vm.$t("pages.permission.status"),
                                value: _vm.permissionStatus,
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm.isInitialized
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("suc-text-form-show-field", {
                              attrs: {
                                title: _vm.$t(
                                  "pages.permission.absences.type_absenses"
                                ),
                                value: _vm.detail.causeOfAbsenceDescription,
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm.isInitialized
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("suc-text-form-show-field", {
                              attrs: {
                                title: _vm.$t(
                                  "pages.permission.absences.start_date"
                                ),
                                value: _vm.detail.dateStart,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c("formatted-date-component", {
                                          attrs: {
                                            val: props.value,
                                            withTime: true,
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3913778375
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("suc-text-form-show-field", {
                              attrs: {
                                title: _vm.$t(
                                  "pages.permission.absences.end_date"
                                ),
                                value: _vm.detail.dateEnd,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c("formatted-date-component", {
                                          attrs: {
                                            val: props.value,
                                            withTime: true,
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3913778375
                              ),
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm.isInitialized && _vm.detail.comments
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("suc-text-form-show-field", {
                              attrs: {
                                title: _vm.$t(
                                  "pages.permission.absences.comments"
                                ),
                                value: _vm.detail.comments,
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm.isInitialized
                    ? _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { staticClass: "label-description" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("pages.permission.attachments"))
                              ),
                            ]),
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "description" },
                                _vm._l(
                                  _vm.detail.attachments,
                                  function (attachment) {
                                    return _c(
                                      "a",
                                      {
                                        key: attachment.key,
                                        attrs: { target: "_blank", href: "#" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.downLoadAttachment(
                                              attachment
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(attachment.name))]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ],
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }